import { IRequirementDefinitionResponse } from "@wingspanhq/payments/dist/interfaces";
import { useMutationUpdateSharedFile } from "../../../../../query/sharedFile/mutations/useMutationUpdateSharedFile";
import { getSharedFileDefaultValues } from "./getSharedFileDefaultValues";

// Params type for the hook
// dataSourceId here refers to the sharedFileId
// This matches the pattern of useEditBackgroundChecksRequirementDefinition

type Params = {
  dataSourceId: string;
};

export const useEditSharedFileRequirementDefinition = ({
  dataSourceId
}: Params) => {
  const [updateSettings, updateSettingsMeta] = useMutationUpdateSharedFile();

  const onSubmit = async (
    formValues: ReturnType<typeof getSharedFileDefaultValues>
  ) => {
    alert("Not implemented");
  };

  return {
    onSubmit,
    ...updateSettingsMeta
  };
};
